import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { useTranslation } from 'react-i18next';
import { useFormState } from 'react-final-form';
import useMobile from 'src/shared/hooks/useMobile';
import { useGetUserHoldingQuery } from 'src/shared/api/holding';
import { getCurrencySymbol } from 'src/shared/utils/currency';
import { getLocaleFromIsoCode } from 'src/shared/utils/locale';
import { FormContentSection } from '../CategoriesGroup/Form/FormContentSection';
import GroupHeader from '../GroupHeader';
import { ReadOnlyLockedField } from '../ReadOnlyLockedField';

const AnnualConsumptionGroup = () => {
  const isMobile = useMobile();
  const { t } = useTranslation(['flexflow']);
  const { values } = useFormState();
  const { data: holdingData } = useGetUserHoldingQuery();

  const currencySymbol = getCurrencySymbol(holdingData?.territory?.isoCode, holdingData?.territory?.currency);
  const locale = getLocaleFromIsoCode(holdingData?.territory?.isoCode);

  const formatNumber = (value?: number | null) =>
    value == null
      ? ''
      : new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);

  const formatPercentage = (value?: number) => {
    const formattedValue = formatNumber(value);
    return formattedValue === '' ? '' : `${formattedValue}%`;
  };

  return (
    <Grid2 container>
      <GroupHeader marginTop={32}>{t('employeeDetails.annualConsumption.title')}</GroupHeader>

      <Grid2 mb={4} xs={12} sx={{ maxWidth: '964px' }}>
        <FormContentSection
          isMobile={isMobile}
          title={t('employeeDetails.annualConsumption.subtitle')}
          description={`${t('employeeDetails.annualConsumption.description1')}<br />${t(
            'employeeDetails.annualConsumption.description2'
          )}`}
        >
          <ReadOnlyLockedField
            name="payflowConsumption"
            label={t('employeeDetails.annualConsumption.payflowConsumption')}
            value={formatNumber(values?.annualConsumption)}
            prefix={currencySymbol}
            sx={{ flex: 1 }}
          />
          <ReadOnlyLockedField
            name="importedConsumption"
            label={t('employeeDetails.annualConsumption.importedConsumption')}
            value={formatNumber(values?.externalAnnualConsumption)}
            prefix={currencySymbol}
            sx={{ flex: 1 }}
          />
          <ReadOnlyLockedField
            name="usagePercentage"
            label={t('employeeDetails.annualConsumption.usagePercentage')}
            value={formatPercentage(values?.annualConsumptionPercentage)}
            sx={{ flex: 1 }}
          />
        </FormContentSection>
      </Grid2>
    </Grid2>
  );
};

export default AnnualConsumptionGroup;
